import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from '../encyption.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import moment from 'moment';
@Injectable({
    providedIn: 'root',
})
export class FerienFiltersService {
    private filters: BehaviorSubject<FerienFIlters>;
    myferienfilters: FerienFIlters = {} as FerienFIlters;
    protected extrasCount: BehaviorSubject<number>;

    beliebteFilter: any[] = [];
    minPrice: number = 9;
    maxPrice: number = 1000;

    adults: number = 1;
    children: number = 0;
    childrenAges: number[] = [];

    start: string = '';
    end: string = '';
    dauer: string = '';

    bedrooms: number = 1;
    toCenter: number;
    toWater: number;
    toSki: number;

    rating: string;

    types: any[] = [
        {
            name: 'Ferienhaus',
            id: 'HOLIDAY_HOUSE',
            isBeliebte: true,
        },
        {
            name: 'Ferienwohnung',
            id: 'HOLIDAY_APARTMENT',
            isBeliebte: true,
        },
        {
            name: 'Privatzimmer',
            id: 'DEDICATED_ROOM',
            isBeliebte: false,
        },
        {
            name: 'Ferienpark',
            id: 'HOLIDAY_PARK',
            isBeliebte: false,
        },
        {
            name: 'Schloss',
            id: 'CASTLE',
            isBeliebte: false,
        },
        {
            name: 'Schiff',
            id: 'BOAT',
            isBeliebte: false,
        },
        {
            name: 'Camping-Unterkunft',
            id: 'CAMPING_SUITE',
            isBeliebte: false,
        },
        {
            name: 'Bauernhof',
            id: 'FARM',
            isBeliebte: false,
        },
        {
            name: 'Gemeinschaftszimmer',
            id: 'SHARED_ROOM',
            isBeliebte: false,
        },
        {
            name: 'Hotel',
            id: 'HOTEL',
            isBeliebte: false,
        },
        {
            name: 'Bed & Breakfast',
            id: 'BED_AND_BREAKFAST',
            isBeliebte: false,
        },
        {
            name: 'Hostel',
            id: 'HOSTEL',
            isBeliebte: false,
        },
        {
            name: 'Motel',
            id: 'PENSION',
            isBeliebte: false,
        },
    ];

    amenities: any[] = [
        {
            name: 'Haustiere erlaubt',
            id: 'PETS_ALLOWED',
            isBeliebte: true,
        },
        {
            name: 'Parkmöglichkeit',
            id: 'GARAGE',
            isBeliebte: true,
        },
        {
            name: 'WLAN',
            id: 'INTERNET',
            isBeliebte: true,
        },
        {
            name: 'Balkon/Terrasse',
            id: 'TERRACE',
            isBeliebte: true,
        },
        {
            name: 'TV',
            id: 'TV',
            isBeliebte: true,
        },
        {
            name: 'Sauna',
            id: 'SAUNA',
            isBeliebte: true,
        },
        {
            name: 'Pool',
            id: 'POOL',
            isBeliebte: true,
        },
        {
            name: 'Küche',
            id: 'KITCHEN',
            isBeliebte: true,
        },
        {
            name: 'Familienfreundlich',
            id: 'CHILDREN_FRIENDLY',
            isBeliebte: false,
        },
        {
            name: 'Spülmaschine',
            id: 'DISHWASHER',
            isBeliebte: false,
        },
        {
            name: 'Waschmaschine',
            id: 'WASHING_MACHINE_AVAILABLE',
            isBeliebte: false,
        },
        {
            name: 'Angeln',
            id: 'FISHING',
            isBeliebte: false,
        },
        {
            name: 'Klimaanlage',
            id: 'AIR_CONDITIONING',
            isBeliebte: false,
        },
        {
            name: 'Kamin/Ofen',
            id: 'FIREPLACE',
            isBeliebte: false,
        },
        {
            name: 'Mikrowelle',
            id: 'MICROWAVE',
            isBeliebte: false,
        },
        {
            name: 'Kinderbett',
            id: 'COT',
            isBeliebte: false,
        },
        {
            name: 'Barrierefrei',
            id: 'ACCESSIBLE',
            isBeliebte: false,
        },
        {
            name: 'Haustiere nicht gestattet',
            id: 'NO_DOGS',
            isBeliebte: false,
        },
        {
            name: 'Rauchen erlaubt',
            id: 'SMOKING_ALLOWED',
            isBeliebte: false,
        },
        {
            name: 'Nichtraucher',
            id: 'SMOKING_NOT_ALLOWED',
            isBeliebte: false,
        },
        {
            name: 'Telephone',
            id: 'TELEPHONE',
            isBeliebte: false,
        },
        {
            name: 'Minibar',
            id: 'MINIBAR',
            isBeliebte: false,
        },
        {
            name: 'Spa',
            id: 'SPA',
            isBeliebte: false,
        },
        {
            name: 'Whirlpool',
            id: 'WHIRLPOOL',
            isBeliebte: false,
        },
        {
            name: 'Grill',
            id: 'BARBECUE',
            isBeliebte: false,
        },
        {
            name: 'Garten',
            id: 'GARDEN',
            isBeliebte: false,
        },
        {
            name: 'Umzäunt',
            id: 'FENCED',
            isBeliebte: false,
        },
        {
            name: 'Freistehend',
            id: 'DETACHED',
            isBeliebte: false,
        },
    ];


    constructor(
        protected router: Router,
        protected encservice: EncryptionService,
        protected route: ActivatedRoute,
        protected location: Location,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.filters = new BehaviorSubject(null);
        this.extrasCount = new BehaviorSubject(0);
        if (isPlatformBrowser(this.platformId)) {
            this.initFilters();
        }
    }

    get getfilters$() {
        return this.filters.asObservable();
    }

    get extrasCount$(): Observable<number> {
        return this.extrasCount.asObservable();
    }

    initFilters(): void {
        this.setDefault();
        if (this.route.snapshot.queryParams['params'] && this.route.snapshot.queryParams['params'].length > 0) {
            const tokenFromUI = this.route.snapshot.queryParams['params']?.slice(-16);
            const data = this.route.snapshot.queryParams['params']?.slice(0, (this.route.snapshot.queryParams['params'].length - 16));
            this.myferienfilters = JSON.parse(this.encservice.deencrypt(tokenFromUI, data));
        }
        this.updateFilters();
        this.filters.next(this.myferienfilters);
    }

    setDefault(): void {
        this.myferienfilters = {} as FerienFIlters;
        this.myferienfilters.productType = 'ferienhauser';
        this.myferienfilters.minPrice = 9;
        this.myferienfilters.maxPrice = 1000;

        this.myferienfilters.bedrooms = 1;
        this.myferienfilters.toCenter = null;
        this.myferienfilters.toWater = null;
        this.myferienfilters.toSki = null;
        this.myferienfilters.rating = null;

        this.myferienfilters.adults = 1;
        this.myferienfilters.children = 0;
        this.myferienfilters.childrenAges = [];

        this.myferienfilters.dauer = '7';
        this.myferienfilters.start = moment().add(4, 'days').format('YYYY-MM-DD');
        this.myferienfilters.end = moment().add(180, 'days').format('YYYY-MM-DD');
    }

    updateFilters(): void {
        this.myferienfilters.minPrice = this.myferienfilters.minPrice ? this.myferienfilters.minPrice : 9;
        this.myferienfilters.maxPrice = this.myferienfilters.maxPrice ? this.myferienfilters.maxPrice : 1000;

        this.minPrice = this.myferienfilters.minPrice;
        this.maxPrice = this.myferienfilters.maxPrice;

        if (this.myferienfilters.bedrooms) {
            this.bedrooms = this.myferienfilters.bedrooms;
        } else {
            this.myferienfilters.bedrooms = 1;
            this.bedrooms = 1;
        }

        this.toCenter = this.myferienfilters.toCenter;
        this.toWater = this.myferienfilters.toWater;
        this.toSki = this.myferienfilters.toSki;
        this.rating = this.myferienfilters.rating;

        this.initDate();

        if (this.myferienfilters.adults) {
            this.adults = this.myferienfilters.adults;
        } else {
            this.myferienfilters.adults = 1;
            this.adults = 1;
        }
        if (this.myferienfilters.children) {
            this.children = this.myferienfilters.children;
        } else {
            this.myferienfilters.children = 0;
            this.children = 0;
        }
        this.childrenAges = this.myferienfilters.childrenAges ? this.myferienfilters.childrenAges : [];

        this.setTypes(this.myferienfilters);
        this.setAmenities(this.myferienfilters);
    }

    initDate(): void {
        if (!isNaN(Number(this.myferienfilters.start))) {
            this.start = moment().add(Number(this.myferienfilters.start), 'days').format('YYYY-MM-DD');
            this.myferienfilters.start = this.start;
        } else if (this.myferienfilters.start?.length > 0) {
            this.start = moment(this.myferienfilters.start).format('YYYY-MM-DD');
        } else {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.myferienfilters.start = moment().add(4, 'days').format('YYYY-MM-DD');
        }

        if (!isNaN(Number(this.myferienfilters.end))) {
            this.end = moment().add(Number(this.myferienfilters.end), 'days').format('YYYY-MM-DD');
            this.myferienfilters.end = this.end;
        } else if (this.myferienfilters.end?.length > 0) {
            this.end = moment(this.myferienfilters.end).format('YYYY-MM-DD');
        } else {
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
            this.myferienfilters.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }

        if (moment(this.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }

        if (this.myferienfilters.dauer === '-1') {
            this.dauer = moment.duration(moment(this.end)
                .diff(moment(this.start))).asDays() + '';
        } else if (this.myferienfilters.dauer?.length > 0) {
            this.dauer = this.myferienfilters.dauer;
        } else {
            this.dauer = '7';
            this.myferienfilters.dauer = '7';
        }
    }

    setTypes(params): void {
        this.beliebteFilter = [];
        for (let i = 0; i < this.types.length; i++) {
            this.types[i].selected = false;
            for (let j = 0; j < params?.types?.length; j++) {
                if (params.types[j].id === this.types[i].id) {
                    this.types[i].selected = true;
                    j = params.types.length;
                }
            }
            if (this.types[i].isBeliebte) {
                this.beliebteFilter.push(this.types[i])
            }
        }
    }

    setAmenities(params): void {
        for (let i = 0; i < this.amenities.length; i++) {
            this.amenities[i].selected = false;
            for (let j = 0; j < params?.amenities?.length; j++) {
                if (params.amenities[j].id === this.amenities[i].id) {
                    this.amenities[i].selected = true;
                    j = params.amenities.length;
                }
            }

            if (this.amenities[i].isBeliebte) {
                this.beliebteFilter.push(this.amenities[i])
            }
        }
    }

    setExtraCount(value) {
        this.extrasCount.next(value);
    }

    openMapModal(): void { }

    setFilters(myferienfilters): void {
        this.myferienfilters = myferienfilters;
        this.updateFilters();
        this.filters.next(this.myferienfilters);
    }

    reisedauerResult(value): void {
        this.myferienfilters.dauer = value;
        if (this.myferienfilters.dauer === '-1') {
            this.dauer = moment.duration(moment(this.end)
                .diff(moment(this.start))).asDays() + '';
        } else {
            this.dauer = this.myferienfilters.dauer;
        }
    }

    reisezeitraumResult(value, setDauer?: boolean): void {
        this.myferienfilters.start = value?.start;
        this.myferienfilters.end = value?.end;

        this.start = value?.start;
        this.end = value?.end;

        if (setDauer) {
            this.dauer = moment.duration(moment(this.end)
                .diff(moment(this.start))).asDays() + '';
            this.myferienfilters.dauer = this.dauer;
        }
    }

    bedroomsresult(): void {
        this.myferienfilters.bedrooms = this.bedrooms;
        this.changeUrl();
    }

    toCenterResult(): void {
        this.myferienfilters.toCenter = this.toCenter;
        this.changeUrl();
    }

    toWaterResult(): void {
        this.myferienfilters.toWater = this.toWater;
        this.changeUrl();
    }

    toSkiResult(): void {
        this.myferienfilters.toSki = this.toSki;
        this.changeUrl();
    }

    toRatingResult(): void {
        this.myferienfilters.rating = this.rating;
        this.changeUrl();
    }

    gotochangeurl(): void {
        this.changeUrl();
    }

    reisendeResult(isHome): void {
        this.myferienfilters.adults = this.adults;
        this.myferienfilters.children = this.children;
        this.myferienfilters.childrenAges = this.childrenAges;
        if (!isHome) {
            this.changeUrl();
        }
    }

    reisezielResult(value): void {
        this.myferienfilters.reisezielResult = value;
    }

    reisezielResultGo(value): void {
        this.myferienfilters.reisezielResult = value;
        this.changeUrl();
    }

    amenitiesTypesResult(ishome): void {
        const amenities = [];
        const types = [];
        for (let i = 0; i < this.types.length; i++) {
            if (this.types[i].selected) {
                types.push({
                    name: this.types[i].name,
                    id: this.types[i].id
                });
            }
        }
        for (let i = 0; i < this.amenities.length; i++) {
            if (this.amenities[i].selected) {
                amenities.push({
                    name: this.amenities[i].name,
                    id: this.amenities[i].id
                });
            }
        }
        this.myferienfilters.amenities = amenities;
        this.myferienfilters.types = types;
        if (!ishome) {
            this.changeUrl();
        }
    }

    typesResult(): void {
        const types = [];
        for (let i = 0; i < this.types.length; i++) {
            if (this.types[i].selected) {
                types.push({
                    name: this.types[i].name,
                    id: this.types[i].id
                });
            }
        }
        this.myferienfilters.types = types;
        this.changeUrl();
    }

    amenitiesResult(): void {
        const amenities = [];
        for (let i = 0; i < this.amenities.length; i++) {
            if (this.amenities[i].selected) {
                amenities.push({
                    name: this.amenities[i].name,
                    id: this.amenities[i].id
                });
            }
        }
        this.myferienfilters.amenities = amenities;
        this.changeUrl();
    }

    minmaxprcResult(): void {
        this.myferienfilters.minPrice = this.minPrice;
        this.myferienfilters.maxPrice = this.maxPrice;
        this.changeUrl();
    }

    minprcResult(value): void {
        this.myferienfilters.minPrice = value?.min;
        this.changeUrl();
    }

    maxprcResult(value): void {
        this.myferienfilters.maxPrice = value?.max;
        this.changeUrl();
    }

    productType(value): void {
        this.myferienfilters.productType = value;
        this.changeUrl();
    }

    changeUrl(): void {
        const url = this.router.createUrlTree([], { queryParams: { params: this.encservice.encrypt(this.myferienfilters), replaceUrl: true } }).toString();
        this.location.replaceState(url);
        this.filters.next(this.myferienfilters);
    }

    resetFilters(): void {
        for (let i = 0; i < this.amenities.length; i++) {
            this.amenities[i].selected = false;
        }
        this.myferienfilters.amenities = null;
        for (let i = 0; i < this.types.length; i++) {
            this.types[i].selected = false;
        }
        this.myferienfilters.types = null;
        this.myferienfilters.amenities = null;

        this.minPrice = 9;
        this.maxPrice = 1000;
        this.myferienfilters.bedrooms = 1;
        this.myferienfilters.minPrice = 9;
        this.myferienfilters.maxPrice = 1000;

        this.myferienfilters.adults = 1;
        this.myferienfilters.children = 0;
        this.myferienfilters.childrenAges = [];

        this.myferienfilters.toCenter = null;
        this.myferienfilters.toWater = null;
        this.myferienfilters.toSki = null;
        this.myferienfilters.rating = null;

        this.bedrooms = 1;
        this.toWater = null;
        this.toSki = null;
        this.toCenter = null;
        this.rating = null;

        this.adults = 1;
        this.children = 0;
        this.childrenAges = [];

        this.changeUrl();
    }

    gotoUrl(): void {
        // console.log(this.myferienfilters);
        const url = this.router.createUrlTree(['ferienhause'], { queryParams: { params: this.encservice.encrypt(this.myferienfilters), replaceUrl: true } }).toString();
        this.router.navigateByUrl(url);
        this.filters.next(this.myferienfilters);
    }
}
